var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{staticClass:"video-props",attrs:{"width":"100%","autoplay":"autoplay","loop":"","muted":"","src":require("../assets/mediapal-hero-video.mp4")},domProps:{"muted":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }